/* The header bag still points at /cart. With the drawer on, that link should slide the
   drawer open instead of loading a whole page. Modified clicks and middle clicks are left
   alone so people can still open the cart page in a new tab on purpose. */
(function () {
  if (window.__gtcOpen) return;
  window.__gtcOpen = 1;
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    var href = a.getAttribute('href') || '';
    if (!/^\/cart\/?(\?|$)/.test(href)) return;
    var d = document.getElementById('cart-drawer');
    if (!d || typeof d.open !== 'function') return;
    e.preventDefault();
    d.open();
    if (window.GTC) window.GTC.decorate();
  }, true);
})();
